import { render, staticRenderFns } from "./NotificationHistoryTable.vue?vue&type=template&id=5e21d4b8"
import script from "./NotificationHistoryTable.vue?vue&type=script&lang=js"
export * from "./NotificationHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationHistoryTable.vue?vue&type=style&index=0&id=5e21d4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports